module.exports = __webpack_public_path__ + "static/media/tut-8-2.b885c7b4.png";